<template>
  <div v-if="report" id="report-show" :class="{ printing: isPrinting }">
    <div class="d-flex align-items-start">
      <div class="card card-nav mr-3">
        <div class="card-body p-0">
          <ul class="list-unstyled">
            <li>
              <button class="btn btn-primary w-100" @click="print">
                <span><i class="tio-download-to"></i> Stampa</span>
              </button>
            </li>
            <li v-for="(category, i) in report.categories" :key="i" :data-target="`#${category.key}`" @click="goTo(category.key)" :class="{ active: isTargetSelected(category.key) }">
              <span><i class="tio-home-vs"></i> {{ category.name }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="card-nav-content flex-fill">
        <div v-if="isPrinting" class="d-flex align-items-center justify-content-between my-4">
          <div class="p-3" style="width: 20rem">
            <img class="w-100" src="/images/cashouse_logo.png" alt="Logo" />
          </div>
          <div>
            <h3 class="text-primary font-weight-bold mb-1">Perizia: {{ property.code }}</h3>
            <div>{{ address }}</div>
          </div>
        </div>

        <div v-for="(category, categoryIndex) in report.categories" :key="categoryIndex" :id="category.key" class="card">
          <div class="card-header">
            <h3 class="mb-0">{{ category.name }}</h3>
            <button class="btn btn-primary" @click="reportGoToCategory(category.key)">Modifica</button>
          </div>
          <div class="card-body">
            <template v-for="(section, sectionIndex) in category.sections">
              <template v-if="section.sectionType == 'single'">
                <report-form-show :categories="report.categories" :form="section.form" :key="`section-${sectionIndex}`"></report-form-show>
              </template>

              <template v-else>
                <div class="report-item p-4" v-for="(item, itemIndex) in section.items" :key="`section-${sectionIndex}-${itemIndex}`">
                  <report-form-show :categories="report.categories" :form="item"></report-form-show>
                </div>
              </template>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReportFormShow from "./Partials/ReportFormShow";

export default {
  components: {
    ReportFormShow
  },

  data() {
    return {
      target: null,
      property: null,
      report: null,
      isPrinting: false
    };
  },

  mounted() {
    this.property = this.$page.props.property;
    this.report = this.$page.props.report;
    this.isPrinting = this.$page.props.isPrinting;
    if (this.isPrinting) setTimeout(() => window.print(), 1000);
  },

  computed: {
    address() {
      return `${this.property.address} ${this.property.house_number}, ${this.property.postal_code} ${this.property.municipality}`;
    }
  },

  methods: {
    goTo(target) {
      this.target = target;

      $("html,body").animate(
        {
          scrollTop: $(`#${target}`).offset().top - 100
        },
        "slow"
      );
    },

    isTargetSelected(target) {
      return target == this.target;
    },

    reportGoToCategory(categoryKey) {
      this.$inertia.get(`/admin/properties/${this.property.id}/report`, {
        category: categoryKey
      });
    },

    print() {
      window.open(`/admin/properties/${this.property.id}/report-print`, "_blank");
    }
  }
};
</script>

<style lang="scss">
#report-show {
  &.printing {
    .card-nav,
    .card-header button {
      display: none;
    }

    .card {
      box-shadow: none;
      margin: 0;
    }
  }
}
</style>
